module.exports = __webpack_public_path__ + "img/404.3acf2e3b.svg";